"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = clear;
exports.hide = hide;
exports.negative = negative;
exports.positive = positive;
exports.show = show;
require("core-js/modules/es.object.assign.js");
var _toastActionTypes = require("./toastActionTypes");
var defaultToast = {
  headline: null,
  dek: null,
  type: null,
  autoDismissInSeconds: 3,
  // seconds
  dismissText: null,
  onDismiss: null,
  containerClass: null,
  className: null
};
function show() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultToast;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _toastActionTypes.ToastConstants.POSITIVE;
  var payload = Object.assign({}, defaultToast, opts, {
    id: new Date().valueOf(),
    type: type
  });
  return {
    type: _toastActionTypes.SHOW_TOAST,
    payload: payload
  };
}
function positive(opts) {
  return show(opts, _toastActionTypes.ToastConstants.POSITIVE);
}
function negative(opts) {
  return show(opts, _toastActionTypes.ToastConstants.NEGATIVE);
}
function hide(id) {
  return {
    type: _toastActionTypes.HIDE_TOAST,
    payload: id
  };
}
function clear() {
  return {
    type: _toastActionTypes.CLEAR_TOASTS
  };
}